import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import {Button, ModalDelete} from "components";

const ListItem = ({id, name, seo_content, history, handleDelete}) => {
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  return (
    <>
      {isDeleteModalOpen && (
        <ModalDelete
          handleDelete={() => handleDelete(id)}
          handleClose={() => setDeleteModalOpen(false)}
          name={name}
        />
      )}
      <tr key={id}>
        <td>{id}</td>
        <td>{name}</td>
        <td>{seo_content?.slug_url || '-'}</td>
        <td>
          <Button
            type="edit"
            onClick={() => history.push(`static_pages/${id}`)}
          />
          <Button type="delete-bin" onClick={() => setDeleteModalOpen(true)} />
        </td>
      </tr>
    </>
  );
};

export default withRouter(ListItem);
